module.exports = __webpack_public_path__ + "static/media/not-found.af306e13.png";